import React from "react";
import Dropdown from "../DropDown";

interface ProductType {
  product_type_id: number;
  product: string;
}

interface MetadataType {
  award_types: any[];
  product_types: ProductType[];
  agg_functions: any[];
}

interface ProductTypeDropdownProps {
  metadata: MetadataType | null;
  selectedProductType: string;
  onProductTypeChange: (value: string, selectedObj?: ProductType) => void;
  disabled?: boolean;
  className?: string;
  onFocus?: () => void;
}

const ProductTypeDropdown: React.FC<ProductTypeDropdownProps> = ({
  metadata,
  selectedProductType,
  onProductTypeChange,
  disabled,
  className = "",
  onFocus,
}) => {

  const productTypes: ProductType[] = metadata?.product_types || [];

  const options = productTypes.map(p => ({
    value: p.product,
    label: p.product,
  }));

  const handleChange = (value: string) => {
    const obj = productTypes.find(p => p.product === value);
    onProductTypeChange(value, obj);
  };

  return (
    <Dropdown
      options={options}
      selectedValue={selectedProductType}
      onValueChange={handleChange}
      disabled={!!disabled}
      className={className}
      placeholder="Select Product Type"
      onFocus={onFocus}
    />
  );
};

export default ProductTypeDropdown;
